export default __webpack_public_path__ + "static/media/liked.b16b851a.svg";